<template>
  <div>
    <div v-if="getBranchBalances.length > 0">
    <h3 class="text-center mt-3">Şube Bakiyeleri</h3>
  <b-table
      :busy="stockListLoading"
      :fields="branchBalanceListHeaders"
      :items="getBranchBalances"
      caption-top
      class="table table-hover"
      hover
      responsive
      show-empty
      head-row-variant="dark"
      table-variant="white"
  >
    <template #empty="scope">
      <h6 class="text-center my-2">
        {{ scope.loading ? "Lütfen Bekleyin" : "Şube verisi bulunamadı" }}
      </h6>
    </template>
    <template #cell(balance)="data">
      <span v-if="user.RoleGroupId !== '3'">{{ data.item.balance + ' ' + singleStock.unit1  }}</span>
      <span v-if="user.RoleGroupId === '3' && data.item.stockStatus === 1"
                    style="height: 15px; width: 15px; background-color: #04AA6B; border-radius: 50%; display: inline-block;"></span>
      <span v-if="user.RoleGroupId === '3' && data.item.stockStatus === 2"
            style="height: 15px; width: 15px; background-color: #DD1E34; border-radius: 50%; display: inline-block;"></span>
      <span></span>
    </template>
  </b-table>
    </div>
    <div v-if="getWarehouseBalances.length > 0">
    <h3 class="text-center mt-5">Depo Bakiyeleri</h3>
    <b-table
        :busy="stockListLoading"
        :fields="warehouseBalanceListHeaders"
        :items="getWarehouseBalances"
        caption-top
        class="table table-hover"
        hover
        responsive
        show-empty
        head-row-variant="dark"
        table-variant="white"
    >
      <template #empty="scope">
        <h6 class="text-center my-2">
          {{ scope.loading ? "Lütfen Bekleyin" : "Depo yok" }}
        </h6>
      </template>
      <template #cell(balance)="data">
        <span v-if="user.RoleGroupId !== '3'">{{ data.item.balance + ' ' + singleStock.unit1  }}</span>
        <span v-if="user.RoleGroupId === '3' && data.item.stockStatus === 1"
              style="height: 15px; width: 15px; background-color: #04AA6B; border-radius: 50%; display: inline-block;"></span>
        <span v-if="user.RoleGroupId === '3' && data.item.stockStatus === 2"
              style="height: 15px; width: 15px; background-color: #DD1E34; border-radius: 50%; display: inline-block;"></span>
        <span></span>
      </template>
    </b-table>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "ProductBalanceTable",
  props: {
    singleStock: {
      required: true,
      type: Object
    }
  },
  computed: {
    ...mapState("dashboard", ["errorMessageAll"]),
    ...mapState("stock", ["stockList", "stockListHeaders", "stockListLoading", "noStockMessage"]),
    ...mapState("cart", ["cartList", "current", "cartListMetaData"]),
    ...mapState("auth", ["user"]),
    getBranchBalances() {
      return this.singleStock.branchBalances;
    },
    getWarehouseBalances() {
      return this.singleStock.warehouseBalances;
    }
  },
  data () {
    return {
      branchBalanceListHeaders: [
        {
          key : "branchCode",
          label: "Şube Kodu",
          class: 'text-center',
          thStyle: { width: "33%" }
        },
        {
          key : "branchName",
          label: "Şube Adı",
          class: 'text-center',
          thStyle: { width: "33%" }
        },
          {
          key : "balance",
          label: "Şube Bakiye",
            class: 'text-center',
            thStyle: { width: "34%" }
        },
      ],
      warehouseBalanceListHeaders: [
        {
          key : "warehouseCode",
          label: "Depo Kodu",
          class: 'text-center',
          thStyle: { width: "33%" }
        },
          {
          key : "warehouseName",
          label: "Depo Adı",
            class: 'text-center',
            thStyle: { width: "33%" }
        },
        {
          key : "balance",
          label: "Depo Bakiye",
          class: 'text-center',
          thClass: "w-34",
          thStyle: { width: "34%" }
        },
      ]
    }
  },
}
</script>

<style scoped>

</style>